var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 48,
    viewBox: "0 0 162 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0612793 6.85717H20.3783L24.8355 0H30.6419L26.1847 6.85717L20.5774 15.4839L18.0613 19.3548H23.6742L31.7976 6.85717H161.939V42.1225H13.172L9.3516 48H3.54515L7.51249 42.1225H0.0612793V6.85717Z",
    fill: "url(#paint0_linear_1_22342)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.5511,
    y: 8.08154,
    width: 124.163,
    height: 33.0612,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1521 20.343L12.9125 14.3379H7.09571L14.1294 24.3829L6.64191 34.9641H12.4587L16.9928 28.3963L21.6166 34.9641H27.4747L17.1521 20.343Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4585 18.2798H51.7825L49.6754 21.4511H53.2399L55.4585 18.2798Z",
    fill: "#E03A3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2876 22.0348L46.6365 18.2798H42.9993L47.3975 24.561L42.7155 31.1775H46.3528L49.188 27.0706L52.0793 31.1775H55.7424L49.2876 22.0348Z",
    fill: "#303030"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.216 18.2603H69.3244V25.999C69.3244 29.2106 67.4413 31.403 63.5074 31.403C59.5737 31.403 57.6776 29.1977 57.6776 26.0247V18.2732H60.7731V25.9344C60.7731 27.6628 61.7791 28.6559 63.5074 28.6559C65.2228 28.6559 66.216 27.6628 66.216 25.9344V18.2732L66.216 18.2603Z",
    fill: "#303030"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5342 18.2798V21.0012H77.9358V31.1776H74.8662V21.0012H71.2418V18.2798H81.5342Z",
    fill: "#303030"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0914 18.2798V31.1775H92.0217V26.0699H86.5403V31.1775H83.4835V18.2798H86.5403V23.3486H92.0217V18.2798H95.0914Z",
    fill: "#303030"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.359 24.7094C110.359 28.3981 107.38 31.3906 103.691 31.3906C100.002 31.3906 97.0099 28.3981 97.0099 24.7094C97.0099 21.0205 100.002 18.0283 103.691 18.0283C107.38 18.0283 110.359 21.0077 110.359 24.7094ZM107.289 24.6964C107.289 22.7102 105.677 21.0979 103.691 21.0979C101.705 21.0979 100.092 22.7102 100.092 24.6964C100.092 26.6828 101.705 28.295 103.691 28.295C105.677 28.295 107.289 26.6828 107.289 24.6964Z",
    fill: "#303030"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.721 31.171H119.213L116.853 26.9018H115.331V31.1581H112.274V18.2603H118.31C120.993 18.2603 122.644 20.0273 122.644 22.4262C122.644 24.7092 121.212 25.9344 119.819 26.2569L122.721 31.171ZM115.331 23.8579H117.898C118.878 23.8579 119.523 23.2904 119.523 22.4262C119.523 21.5621 118.891 20.9947 117.898 20.9947H115.331V23.8579Z",
    fill: "#303030"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.667 18.2798H127.724V31.1775H124.667V18.2798Z",
    fill: "#303030"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M139.947 18.2798V21.0012H136.349V31.1776H133.279V21.0012H129.655V18.2798H139.947Z",
    fill: "#303030"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M154.536 18.2798L149.764 25.6573V31.1775H146.707V25.6573L141.896 18.2798H145.392L148.229 22.8714L151.041 18.2798H154.536Z",
    fill: "#303030"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_22342",
    x1: 85.1818,
    y1: 57.5384,
    x2: 85.5819,
    y2: -6.87103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E91515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B92929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#D03939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E03A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F13F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04646"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d4afb28884ef8ca2b4e25d5c41a0a50a.svg";
export { ForwardRef as ReactComponent };